import { CONSTANTS } from '../config/constants';

document.addEventListener('DOMContentLoaded', () => {
	if (document.getElementById('map-draw')) {
		const shape_field = document.getElementById('shape_field');

		let map = new mapboxgl.Map({
			container: 'map-draw',
			style: CONSTANTS.map_style,
			center: CONSTANTS.map_center,
			zoom: 16,
			minZoom: 13,
			maxZoom: 20,
			maxBounds: [
				[-89.6, 42.96],
				[-89.3, 43.2],
			],
			scrollZoom: true,
			pitchWithRotate: false,
			dragRotate: false,
			hash: false,
			trackResize: true,
		});

		const draw = new MapboxDraw({
			displayControlsDefault: false,
			// Select which mapbox-gl-draw control buttons to add to the map.
			controls: {
				polygon: true,
				trash: true,
			},
			// Set mapbox-gl-draw to draw by default.
			// The user does not have to click the polygon control button first.
			defaultMode: 'draw_polygon',
			styles: drawStyles,
		});
		map.addControl(draw);

		map.on('load', () => {
			// if current map_object was drawn, add it and select it for editing
			if (W.map_object?.geojson) {
				const featureIds = draw.add(W.map_object.geojson);
				draw.changeMode('direct_select', { featureId: featureIds[0] });
				map.panTo(W.map_object.lnglat);
			}
		});

		const captureShape = (e) => {
			const justDrawnPolygon = e.features[0];
			draw.getAll().features.forEach((polygon) => {
				if (polygon.id !== justDrawnPolygon.id) {
					draw.delete(polygon.id);
				}
			});
			const points = justDrawnPolygon.geometry.coordinates[0];
			const wkt = polyWKT(points);
			shape_field.value = wkt;
		};

		map.on('draw.create', captureShape);
		map.on('draw.delete', captureShape);
		map.on('draw.update', captureShape);

		// Polygon LatLngs to Mercator WKT
		const polyWKT = (points) => {
			const wktPoints = [];
			points.forEach((point) => {
				let wktGeojson = turf.toMercator(turf.point(point));
				let wktPoint = wktGeojson.geometry.coordinates;
				wktPoints.push(wktPoint[0] + ' ' + wktPoint[1]);
			});
			// joins the wktPoints and close the polygon by appending
			// the starting point at the end
			return 'POLYGON ((' + wktPoints.join(', ') + ', ' + wktPoints[0] + '))';
		};
	}
});

const drawStyles = [
	// ACTIVE (being drawn)
	// line stroke
	{
		id: 'gl-draw-line',
		type: 'line',
		filter: ['all', ['==', '$type', 'LineString']],
		layout: {
			'line-cap': 'round',
			'line-join': 'round',
		},
		paint: {
			'line-color': '#D20C0C',
			'line-dasharray': [0.2, 2],
			'line-width': 2,
		},
	},
	// polygon fill
	{
		id: 'gl-draw-polygon-fill',
		type: 'fill',
		filter: ['all', ['==', '$type', 'Polygon']],
		paint: {
			'fill-color': '#D20C0C',
			'fill-outline-color': '#D20C0C',
			'fill-opacity': 0.1,
		},
	},
	// polygon mid points
	{
		id: 'gl-draw-polygon-midpoint',
		type: 'circle',
		filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
		paint: {
			'circle-radius': 4,
			'circle-color': '#3b77fb',
		},
	},
	// polygon outline stroke
	// This doesn't style the first edge of the polygon, which uses the line stroke styling instead
	{
		id: 'gl-draw-polygon-stroke-active',
		type: 'line',
		filter: ['all', ['==', '$type', 'Polygon']],
		layout: {
			'line-cap': 'round',
			'line-join': 'round',
		},
		paint: {
			'line-color': '#D20C0C',
			'line-dasharray': [0.2, 2],
			'line-width': 2,
		},
	},
	// vertex point halos
	{
		id: 'gl-draw-polygon-and-line-vertex-halo-active',
		type: 'circle',
		filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']],
		paint: {
			'circle-radius': 7,
			'circle-color': '#FFF',
		},
	},
	// vertex points
	{
		id: 'gl-draw-polygon-and-line-vertex-active',
		type: 'circle',
		filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']],
		paint: {
			'circle-radius': 5,
			'circle-color': '#D20C0C',
		},
	},
];
